<template>
  <nav class="u-flex nav">
    <div class="u-flex u-row-between container" style="width: 1700px">
      <div class="u-flex ">
        <h1 class="logo">

          <a href="/">卓泓IP代理</a>

        </h1>
        <ul class="u-flex menu">
          <li @click="onSelect(0)" :class="{ 'active': curIndex === 0 }">
            <span>首页</span>

          </li>
          <li @click="onSelect(1)" :class="{ 'active': curIndex === 1 }">
            <span>购买代理</span>
            <div class="dropdown-content">
              <div class="u-flex u-col-top">
                <div class="tab">
                  <div class="item" :class="{ 'active': tabIndex === idx }" v-for="(tab, idx) in tabList" :key="idx"
                       @click.s.stop="onTab(idx)">{{ tab }}
                  </div>
                </div>
                <div class="u-flex u-col-top tab-content" v-if="tabIndex === 0">
                  <ul class="u-flex">
                    <li>
                      <h4>代理产品</h4>
                      <div style="padding: 20px" @click.stop=" () => { index1 = 0;$router.push({
                      path: '/abroad-ip-goods'
                      }) }" class="u-flex"
                           :class="{ 'ip': index1 === 0 }">
                        <img src="../assets/images/gmdl_ywdz_icon1.png" alt="">
                        <div class="ml20">
                          <div class="u-flex">短效动态IP</div>
                          <p class="mt10">全国300+城市级定位节点，3/5/15/30/60分钟，只吃高并发提取</p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <h4>业务定制</h4>
                      <div style="padding: 20px" @click.stop="() => {
                        index1 = 1;
                        $router.push({
                          path: '/china-ip-goods',
                          query: {
                            tabIndex1: 1
                          }
                        })
                      }" class="u-flex" :class="{ 'ip': index1 === 1 }">
                        <img src="../assets/images/gmdl_dtdl_icon1.png" alt="">
                        <div class="ml20 ">

                          <div class="u-flex">优质/企业/精选IP</div>
                          <p class="mt10">1000+企业首选，大客户经理1V1定制专属解决方案技术团队24小时支持</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="mt20">
                    <img src="../assets/images/gmdl_pic2.png" alt="">
                  </div>
                </div>
                <div class="u-flex u-col-top tab-content" v-else>
                  <ul class="u-flex">
                    <li @click.stop="() => { index2 = 0 ;$router.push({
                      path: '/china-ip-goods'
                      })}">
                      <h4>代理产品</h4>
                      <div style="padding: 20px" class="u-flex " :class="{ 'ip': index2 === 0 }">
                        <img src="../assets/images/gmdl_ywdz_icon1.png" alt="">
                        <div class="ml20">
                          <!-- <div class="u-flex">短效动态IP <em class="ml10 discount">折扣45%</em></div> -->
                          <div class="u-flex">短效动态IP</div>
                          <p>全国300+城市级定位节点，3/5/10/15/30分钟，只吃高并发提取</p>
                        </div>
                      </div>
                    </li>
                    <li @click.stop="() => {
                      index2 = 1;
                      $router.push({
                        path: '/china-ip-goods',
                        query: {
                          tabIndex1: 1
                        }
                      })
                    }">
                      <h4>业务定制</h4>
                      <div style="padding: 20px" class="u-flex" :class="{ 'ip': index2 === 1 }">
                        <img src="../assets/images/gmdl_dtdl_icon1.png" alt="">
                        <div class="ml20">
                          <div class="u-flex">优质/企业/精选IP</div>
                          <p>1000+企业首选，大客户经理1V1定制专属解决方案技术团队24小时支持</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="mt20">
                    <img src="../assets/images/gmdl_pic2.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li @click="onSelect(2)" :class="{ 'active': curIndex === 2 }">
            <span>api接口</span>
          </li>
          <li :class="{ 'active': curIndex === 3 }" style="position: relative;" @mouseenter="onProductIntroHover"
              @mouseleave="onProductIntroLeave">
            <span>产品介绍</span>
            <div class="product-intro-dropdown" v-if="showProductDropdown">
              <div class="intro-cards">
                <div class="intro-card" v-for="(product, idx) in productCards" :key="idx" :class="getCardClass(product)"
                     @click.stop="onSelect(3);goToProduct(product)">
                  <div class="card-header">
                    <h3>{{ product.title }}</h3>
                  </div>
                  <div class="card-content">
                    <p>{{ product.description }}</p>
                  </div>
                  <div class="card-action">
                    <el-button type="primary" size="small" round>查看详情</el-button>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li @click="onSelect(4)" :class="{ 'active': curIndex === 4 }">
            <span>帮助文档</span>
          </li>
          <li @click="onSelect(5)" :class="{ 'active': curIndex === 5 }">
            <span>企业服务</span>
          </li>
        </ul>
      </div>
      <div>

        <el-button type="text" @click="onLogin" v-if="!isLogin">登录</el-button>
        <el-button type="text" @click="$router.push('/user')" v-if="isLogin">个人中心</el-button>
        <el-button type="text" @click="onLogout" v-if="isLogin">退出登录</el-button>
        <el-button class="ml36" type="primary" size="small" @click="onRE" v-if="!isLogin">注册</el-button>
      </div>
    </div>
  </nav>
</template>
<script>

import {removerToken, getToken} from "@/utils/cache";

export default {
  name: "Head",
  computed: {
    isLogin() {
      let token = getToken();
      return !(token == undefined || token == "");
    }
  },
  data() {
    return {
      index1: 0,
      index2: 0,
      keywords: "", // 搜索关键按词
      curIndex: 0,
      company: {
        qrcode: require("../../static/other/公众号二维码.jpg"),
      },
      scroll: '',
      timer: '',
      seen: true,
      currentMenu: '首页',
      tabIndex: 0,
      tabList: ['国外代理', '国内代理'],
      productCards: [],
      showProductDropdown: false,
      isLoadingProducts: false
    };
  },
  mounted() {
    this.menuSeen()

  },
  created() {


  },
  methods: {
    onRE() {
      this.$router.push({
        path: "/login",
        query: {
          curIndex: 1,
        }
      })
    },
    onLogout() {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout')

      }).catch(() => {

      })
    },
    onLogin() {
      this.$router.push('/login')
    },
    onSelect(index) {
      this.curIndex = index
      switch (index) {
        case 0:
          this.$router.push({name: "Index"});
          break;
        case 1:
          this.$router.push({
            path: '/abroad-ip-goods',
          })
          break;
        case 2:
          this.$router.push({name: "Interface"});
          break;
        case 3:
          this.$router.push({name: "Introduce"});
          break;
        case 4:
          this.$router.push({name: "Faq"});
          break;
        case 5:
          this.$router.push({name: "Service"});
          break;
        case 6:
          this.$router.push({name: "Service"});
          break;
      }
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    onTab(idx) {

      this.tabIndex = idx
      this.index1 = 0;
      this.index2 = 0;
      if (idx == 0) {
        this.$router.push({
          path: '/abroad-ip-goods',
        })
      }
      if (idx == 1) {
        this.$router.push({
          path: '/china-ip-goods',
        })
      }

    },
    logoClick() {
      this.$router.push({name: "Index"});
      this.currentMenu = '首页';
    },
    goToProduct(product) {
      this.$router.push({
        path: '/Introduce',
        query: {
          id: product.id
        }
      })
    },
    onProductIntroHover() {
      // 调用API获取产品介绍数据
      this.$api.goods.getIntroduce().then(res => {
        this.productCards = res.data;
        this.showProductDropdown = true;
      })
    },
    onProductIntroLeave() {
      // 延迟隐藏，给用户一些时间移动到下拉框
      setTimeout(() => {
        this.showProductDropdown = false;
      }, 200);
    },
    getCardClass(product) {
      const classes = [];

      // 根据ip_type设置背景色 (0为国为, 1为国内)
      if (product.ip_type !== undefined) {
        switch (product.ip_type) {
          case 0: // 国为
            classes.push('card-bg-blue');
            break;
          case 1: // 国内
            classes.push('card-bg-green');
            break;
          default:
            classes.push('card-bg-default');
        }
      }

      // 根据price_type设置边框或强调色
      if (product.price_type) {
        switch (product.price_type) {
          case 'premium':
            classes.push('card-premium');
            break;
          case 'standard':
            classes.push('card-standard');
            break;
          case 'economy':
            classes.push('card-economy');
            break;
        }
      }

      return classes.join(' ');
    }

  }
}
</script>

<style scoped>
.nav {
  position: relative;
  height: 80px;
  background: #fff;

}

.logo {
  width: 142px;
  height: 28px;

}

.logo a {
  width: 100%;
  height: 100%;
  display: block;
  text-indent: -9999px;
  background: url(../assets/images/logo.png) no-repeat;
}

.menu {
  margin-left: 150px;
  box-sizing: border-box;
}

.menu li {
  margin-right: 48px;
  color: #000;
  font-size: 16px;
  cursor: pointer;
}

.menu li span {
  height: 80px;
  line-height: 80px;
  display: block;

}

.menu li:hover span {
  color: #457ff6;
}

.menu li.active {
  color: #457ff6;
}

.dropdown {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 500px;
}

.dropdown-content {
  position: absolute;
  top: 80px !important;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 300px;
  display: none;
  background: #fff;
  border-top: 1px solid #eeeced;
}

.menu li:hover .dropdown-content {
  display: block;
}

.tab {
  width: 351px;
  float: left;
  text-align: right;
  box-sizing: border-box;
  border-right: 1px solid #eeeced;
}

.tab .item {
  padding-right: 20px;
  height: 100px;
  line-height: 100px;
  color: #333;
  font-size: 14px;
}

.tab .active {
  color: #277eff;
  background-image: linear-gradient(to right, #fff, #edf1fc);
  border-right: 1px solid #2584ff;
}

.tab-content {

  padding-left: 40px;
  width: calc(100% - 351px);
  box-sizing: border-box;
}

.tab-content li {
  width: 360px;
}

.tab-content li h4 {
  height: 48px;
  line-height: 48px;
}


.ip {
  /* padding: 20px; */
  border-radius: 4px;
  background: #edf1fc;
}

.tailor {
  padding: 20px;
  border-radius: 4px;
}

.tab-content li p {
  margin-top: 5px;
  color: #999;
  font-size: 14px;
}

/* 产品介绍下拉框样式 */
.product-intro-dropdown {
  position: absolute;
  top: 85px;
  left: 40%;
  transform: translateX(-50%);
  z-index: 1;
  width: 700px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 移除原来的hover显示，现在通过v-if控制 */

.intro-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  padding: 25px;
}

.intro-card {
  background: #fff;
  border: none;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 根据ip_type的背景色配置 */
.card-bg-blue {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
}

.card-bg-green {
  background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
}

.card-bg-default {
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
}

/* 根据price_type的强调色配置 */
.card-premium {
  box-shadow: 0 4px 16px rgba(255, 215, 0, 0.3);
}

.card-premium:hover {
  box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
  transform: translateY(-2px);
}

.card-standard {
  box-shadow: 0 4px 16px rgba(33, 150, 243, 0.2);
}

.card-standard:hover {
  box-shadow: 0 6px 20px rgba(33, 150, 243, 0.3);
  transform: translateY(-2px);
}

.card-economy {
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.2);
}

.card-economy:hover {
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3);
  transform: translateY(-2px);
}


.card-header h3 {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 10px 0;
  line-height: 1.2;
}

.card-content p {
  color: #666;
  font-size: 12px;
  line-height: 1.4;
  margin: 0 0 12px 0;
  flex: 1;
}

.card-action {
  text-align: left;
  margin-top: auto;
}

.card-action .el-button {
  width: auto;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .product-intro-dropdown {
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
  }

  .intro-cards {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 12px;
  }

  .intro-card {
    padding: 10px;
    min-height: 80px;
  }

  .card-header h3 {
    font-size: 13px;
  }

  .card-content p {
    font-size: 10px;
  }
}
</style>
